export default "__VITE_ASSET__iTvPOGTi__"